import React, { useContext, useState, useEffect } from "react";
import { signInWithEmailAndPassword, signOut,sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";
import { db } from "../firebase";
import { collection, getDocs, where, query } from "firebase/firestore";

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState();
  const [userProfile, setuserProfile] = useState();

  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }
  function ResetPassword(email){
    return sendPasswordResetEmail(auth, email);
  }
  function logout() {
    return signOut(auth);
  }

  const [loaded, setloaded] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
      setloaded(true);
    });

    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    logout,
    login,
    loaded,
    userProfile,
    ResetPassword,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
